import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { ListItemIcon, ListItemText } from '@material-ui/core';

import { setNavIsOpen } from '../../../redux/Redux.actions';
import { withStyles } from "@material-ui/styles";
import { styles } from '../Layout.styles.js';
import { theme } from '../Layout.theme';
import { getNavIcon, ChevronRightIcon, ChevronLeftIcon } from '../../_utils/icons';
import { loggedInDevoteeSelector } from '../../../redux/Redux.selectors';
import { ADMIN_LINKS_LIST, NAV_LINKS_LIST, ROUTES } from "../../_utils/constants";

const mapStateToProps = state => ({
  isNavDrawerOpen: state.views.isNavDrawerOpen,
  loggedInDevotee: loggedInDevoteeSelector(state),
});

const mapDispatchToProps = dispatch => ({
  setNavIsOpen: val => dispatch(setNavIsOpen(val)),
});

class NavDrawer extends Component {

  render () {
    const { classes, isNavDrawerOpen, loggedInDevotee } = this.props;
    const { roles: { admin : isAdmin } } = loggedInDevotee;
    return (
      <React.Fragment>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: isNavDrawerOpen,
            [classes.drawerClose]: !isNavDrawerOpen,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: isNavDrawerOpen,
              [classes.drawerClose]: !isNavDrawerOpen,
            }),
          }}
          open={isNavDrawerOpen}
        >
          <div className={classes.toolbar}>
            <div>Menu</div>
            <IconButton onClick={() => this.props.setNavIsOpen(false)}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <List>
            {NAV_LINKS_LIST.map((linkName, index) => { return (
              <Link to={`/${ROUTES[linkName]}`} key={index}>
                <ListItem button>
                  <ListItemIcon>{getNavIcon(linkName)}</ListItemIcon>
                  <ListItemText primary={linkName} />
                </ListItem>
              </Link>
            )})}
          </List>
          <Divider />
          {isAdmin &&
            <List>
              {ADMIN_LINKS_LIST.map((linkName, index) => { return (
                <Link to={`/${ROUTES[linkName]}`} key={index}>
                  <ListItem button>
                    <ListItemIcon>{getNavIcon(linkName)}</ListItemIcon>
                    <ListItemText primary={linkName} />
                  </ListItem>
                </Link>
              )})}
            </List>
          }
        </Drawer>
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(NavDrawer));
